import React, { useState } from 'react';

interface CategoryLessonData {
  categoryName: string;
  categoryId: string;
  lessonsCount: number;
}

interface KnowledgeCategoriesChartProps {
  data: CategoryLessonData[];
}

type SortColumn = 'categoryName' | 'lessonsCount';
type SortDirection = 'asc' | 'desc';

const KnowledgeCategoriesChart: React.FC<KnowledgeCategoriesChartProps> = ({ data }) => {
  const [sortColumn, setSortColumn] = useState<SortColumn>('lessonsCount');
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');

  const handleSort = (column: SortColumn) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('desc');
    }
  };

  const sortedData = [...data].sort((a, b) => {
    let aValue: string | number;
    let bValue: string | number;

    if (sortColumn === 'categoryName') {
      aValue = a.categoryName.toLowerCase();
      bValue = b.categoryName.toLowerCase();
      const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      return sortDirection === 'asc' ? comparison : -comparison;
    } else {
      aValue = a.lessonsCount;
      bValue = b.lessonsCount;
      const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      return sortDirection === 'asc' ? comparison : -comparison;
    }
  });

  return (
    <div className="dashboard-kc-table-container">
      <table className="dashboard-kc-table">
        <thead>
          <tr>
            <th
              className={`dashboard-kc-table-header ${sortColumn === 'categoryName' ? 'sorted' : ''}`}
              onClick={() => handleSort('categoryName')}
            >
              Category Name
              {sortColumn === 'categoryName' && (
                <span className="dashboard-kc-sort-indicator">
                  {sortDirection === 'asc' ? '▲' : '▼'}
                </span>
              )}
            </th>
            <th
              className={`dashboard-kc-table-header ${sortColumn === 'lessonsCount' ? 'sorted' : ''}`}
              onClick={() => handleSort('lessonsCount')}
            >
              Lessons
              {sortColumn === 'lessonsCount' && (
                <span className="dashboard-kc-sort-indicator">
                  {sortDirection === 'asc' ? '▲' : '▼'}
                </span>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.length === 0 ? (
            <tr>
              <td colSpan={2} className="dashboard-kc-table-empty">
                No categories available
              </td>
            </tr>
          ) : (
            sortedData.map((item) => (
              <tr key={item.categoryId} className="dashboard-kc-table-row">
                <td className="dashboard-kc-table-cell dashboard-kc-table-cell-name">
                  {item.categoryName}
                </td>
                <td className="dashboard-kc-table-cell dashboard-kc-table-cell-count">
                  {item.lessonsCount}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default KnowledgeCategoriesChart;

